function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import renderTemplateImpl from '../renderTemplate';
import HeroAdValidatorImpl from './HeroAdValidator';
import NativeAdTrackerImpl from '../NativeAdTracker';

var HeroAdComponent = /*#__PURE__*/function () {
  function HeroAdComponent() {
    var renderTemplate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : renderTemplateImpl;
    var HeroAdValidator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : HeroAdValidatorImpl;
    var NativeAdTracker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : NativeAdTrackerImpl;

    _classCallCheck(this, HeroAdComponent);

    this.renderTemplate = renderTemplate;
    this.HeroAdValidator = HeroAdValidator;
    this.NativeAdTracker = NativeAdTracker;
  }

  _createClass(HeroAdComponent, [{
    key: "processEvent",
    value: function processEvent(json) {
      var _this = this;

      var hotDotContainer = document.querySelector('.hero-ad-container .hot-dot-container');
      var hotDot = document.querySelector('.hero-ad-container .hot-dot');
      var popupCloseButton = document.querySelector('.hero-ad-container .popup-close-button');
      this.NativeAdTracker.trackHeroAds(json.impressiontrackers);
      hotDot.addEventListener('click', function () {
        hotDotContainer.classList.toggle('popup-visible');

        if (hotDotContainer.classList.contains('popup-visible')) {
          _this.NativeAdTracker.trackHeroAds(json.hotdottrackers);
        }
      });
      var isHotDotTrackersFired = false;
      hotDot.addEventListener('mouseenter', function () {
        hotDotContainer.classList.add('popup-visible');

        if (!isHotDotTrackersFired) {
          _this.NativeAdTracker.trackHeroAds(json.hotdottrackers);

          isHotDotTrackersFired = true;
        }
      });

      if (popupCloseButton) {
        popupCloseButton.addEventListener('click', function (e) {
          hotDotContainer.classList.remove('popup-visible');
          e.stopPropagation();
        });
      } else {
        hotDotContainer.addEventListener('mouseleave', function () {
          hotDotContainer.classList.remove('popup-visible');
        });
        document.addEventListener('click', function (e) {
          if (!e.target.className || !e.target.className.match('hot-dot')) {
            hotDotContainer.classList.remove('popup-visible');
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render(json, renderTarget, adSpot) {
      var _this2 = this;

      return this.HeroAdValidator.validate(json).then(function (image) {
        if (adSpot.nativeBeforeRenderCallback) {
          adSpot.nativeBeforeRenderCallback(json, image);
        }

        return _this2.renderTemplate(renderTarget, json);
      }).then(function () {
        _this2.processEvent(json);
      });
    }
  }]);

  return HeroAdComponent;
}();

export default HeroAdComponent;
//# sourceMappingURL=HeroAdComponent.js.map